import React, {useState, useEffect}from 'react'
import Dots from '../../assets/images/blue_dotes.png'
import Email from '../../assets/images/email_icon.png'
import { newsletterApi } from '../../services/api';
import logger from '../../utils/logger';

function Resources() {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(null); // success | error
    const [loading, setLoading] = useState(false);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus(null);
        setLoading(true);
        try {
            const res = await newsletterApi.subscribeNewsletter(email);
            // Check response message for already subscribed
            if (res.message && res.message.includes('Already')) {
                setStatus('already');
            } else {
                setStatus('success');
            }
            setEmail('');
        } catch (err) {
            logger.error('Failed to subscribe to newsletter', err);
            setStatus('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className="our_resource">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="section_title" data-aos="fade-up" data-aos-duration={1500} >
                                <span className="title_badge">Resurse LUMO</span>
                                <h2>
                                    Ultimele postări pe <span>blog</span>
                                </h2>
                                <p>
                                    <span>Descoperă noutăți, sfaturi utile și povești din Universul LUMO</span><br/>
                                    Aici scriem despre tot ce înseamnă LUMO: idei, trucuri, experiențe și update-uri. Intră în culisele aplicației și inspiră-te din poveștile comunității noastre!
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mail_block white_text" data-aos="fade-up" data-aos-duration={1500} >
                                <div className="dotes_blue">
                                    <img src={Dots} alt="image" />
                                </div>
                                <div className="text">
                                    <span className="icon">
                                        <img src={Email} alt="image" />
                                    </span>
                                    <h3>Primește mai mult din <span>LUMO</span></h3>
                                    <p>Primești puncte, noutăți și acces prioritar la tot ce e nou în LUMO. Gratuit, lunar, util.</p>
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <input type="email" className="form-control" placeholder="Introdu adresa ta de email..." value={email} onChange={(e) => setEmail(e.target.value)} required/>
                                            <button className="btn" disabled={loading}>
                                                <i className={`icofont-${loading ? 'spinner-alt-2' : 'paper-plane'}`} />
                                            </button>
                                        </div>
                                        {status === 'success' && <p className="note text-success">Verifică emailul pentru a confirma abonarea.</p>}
                                        {status === 'error' && <p className="note text-danger">A apărut o eroare. Încearcă din nou.</p>}
                                        {status === 'already' && <p className="note text-warning">Ești deja abonat la newsletter.</p>}
                                        <p className="note">
                                            Apăsând butonul ești de acord să primești email-uri din partea LUMO
                                        </p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Resources